import { Box, Typography } from '@mui/material'
import ExportSplitButton from './components/ExportSplitButton'
import {
  METRICS_HEADER_EXPORT_SX,
  METRICS_HEADER_SX,
  METRICS_HEADER_TITLE_SX
} from './style/metricsIndexStyles'

const MetricsHeader = ({
  title,
  onExportPDF,
  onExportExcel
}) => {
  return (
    <Box sx={METRICS_HEADER_SX}>
      <Typography variant="h5" sx={METRICS_HEADER_TITLE_SX}>
        {title}
      </Typography>

      <ExportSplitButton
        sx={METRICS_HEADER_EXPORT_SX}
        onExportPDF={onExportPDF}
        onExportExcel={onExportExcel}
      />
    </Box>
  )
}

export default MetricsHeader
